import { StyleSheet, css } from "aphrodite"
import React from "react";
import { GiHamburgerMenu } from "react-icons/gi";
import { MdClose } from "react-icons/md";
import { compactNavView } from "../commonCss/commonCss";
import { softBlack } from "../theme";

interface BreadCrumbProps {
    isOpen: boolean,
    menuId: string,
    onClick: () => void
}

/** Menu toggle for the navbar links; shown only below the compact navbar width. */
export const BreadCrumb = React.memo(({isOpen, menuId, onClick}: BreadCrumbProps) => {
    return <button
        type="button"
        className={css(styles.breadCrumb)}
        aria-label={isOpen ? "Close menu" : "Open menu"}
        aria-expanded={isOpen}
        aria-controls={menuId}
        onClick={onClick}
    >
        {isOpen ? <MdClose /> : <GiHamburgerMenu />}
    </button>
});

const styles = StyleSheet.create({
    breadCrumb: {
        display: "none",
        alignItems: "center",
        background: "transparent",
        border: "none",
        color: softBlack,
        cursor: "pointer",
        padding: "5px",
        height: "100%",
        fontSize: "1.5rem",
        [compactNavView]: {
            display: "flex",
        },
    },
    span: {
        display: "block",
        width: '30px',
        height: '10px',
        background: softBlack
    }
})
